import { render, staticRenderFns } from "./SGDbOps.vue?vue&type=template&id=1d93ddc2&scoped=true"
import script from "./SGDbOps.vue?vue&type=script&lang=js"
export * from "./SGDbOps.vue?vue&type=script&lang=js"
import style0 from "./SGDbOps.vue?vue&type=style&index=0&id=1d93ddc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d93ddc2",
  null
  
)

export default component.exports